import moment from "moment"
import iconConsumeImg from '@/assets/home/overviewData/icon_consume.png'
import iconGmvImg from '@/assets/home/overviewData/icon_gmv.png'
import iconRatioImg from '@/assets/home/overviewData/icon_ratio.png'
import iconOrderImg from '@/assets/home/overviewData/icon_order.png'
import iconValidOrderImg from '@/assets/home/overviewData/icon_valid_order.png'

export const overviewDataRenderList = [
	{
		name: '消耗',
		key: 'cost',
		updateDateKey: 'costTime',
		image: iconConsumeImg
	},
	{
		name: 'GMV',
		key: 'customerOrderValidTotalSalePrice',
		updateDateKey: 'defaultTime',
		image: iconGmvImg
	},
	{
		name: '投入产出比',
		key: 'inputOutputRatio',
		updateDateKey: 'defaultTime',
		image: iconRatioImg
	},
	{
		name: '订单数',
		key: 'customerOrderNum',
		updateDateKey: 'defaultTime',
		image: iconOrderImg
	},
	{
		name: '有效订单数',
		key: 'customerOrderValidNum',
		updateDateKey: 'defaultTime',
		image: iconValidOrderImg
	}
]

export const chartsTypeOptions = [
	{
		name: '消耗',
		key: 'cost',
		updateDateKey: 'costTime'
	},
	{
		name: 'GMV',
		key: 'customerOrderValidTotalSalePrice',
		updateDateKey: 'defaultTime'
	},
	{
		name: '投入产出比',
		key: 'inputOutputRatio',
		updateDateKey: 'defaultTime'
	},
	{
		name: '订单数',
		key: 'customerOrderNum',
		updateDateKey: 'defaultTime'
	},
	{
		name: '有效订单数',
		key: 'customerOrderValidNum',
		updateDateKey: 'defaultTime'
	}
]


export const overviewPlanDataRenderList = [
	{
		name: '消耗',
		key: 'cost',
		updateDateKey: 'costTime',
		image: iconConsumeImg
	},
	{
		name: 'GMV',
		key: 'orderValidTotalSalePrice',
		updateDateKey: 'defaultTime',
		image: iconGmvImg
	},
	{
		name: '投入产出比',
		key: 'inputOutputRatio',
		updateDateKey: 'defaultTime',
		image: iconRatioImg
	},
	{
		name: '订单数',
		key: 'orderNum',
		updateDateKey: 'defaultTime',
		image: iconOrderImg
	},
	{
		name: '有效订单数',
		key: 'orderValidNum',
		updateDateKey: 'defaultTime',
		image: iconValidOrderImg
	}
]




export const renderSearchList = [
	{
		label: '选择日期',
		key: 'dates',
		type: 'datePicker',
		width: 216,
		datePickerType: 'daterange',
		placeholder: '请选择',
		maxDate: moment(new Date()).subtract(1, 'day').format('YYYY-MM-DD')
		//datePickerConfirm: true
	},
	{
		label: '指标',
		key: 'chartsType',
		type: 'select',
		width: 114,
		placeholder: '请选择',
		clearable: false,
		options: chartsTypeOptions.map((item) => {
			return {
				label: item.name,
				value: item.key
			}
		})
	},
]


// WEBPACK FOOTER //
// ./src/pages/home/overviewData/overviewData/config.js